/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.utilsModule')

/**
 * Directive to include the value of the directive as a complied template.
 *
 * Code for this from:
 * http://fdietz.github.io/recipes-with-angular-js/common-user-interface-patterns/
 *     editing-text-in-place-using-html5-content-editable.html
 * and
 * https://jsfiddle.net/gh8mpdfw/
 */
.directive('bulbInlineEditable', ['$compile', bulbInlineEditable]);

function bulbInlineEditable($compile) {
  return {
    restrict: 'A',
    require: 'ngModel',
    priority: '1',
    link: {
      pre: function(scope, element, attrs, ngModel) {
        element.attr('contenteditable', true);
        element.removeAttr('bulb-inline-editable');
        $compile(element)(scope);
      },
      post: function(scope, element, attrs, ngModel) {
        function read(eventType) {
          var html = element.html();
          // Chrome has a bug that inserts &nbsp; instead of spaces within contenteditable elements
          // https://bugs.chromium.org/p/chromium/issues/detail?id=310149
          html = html.replace(/&nbsp;/g, '\u00a0');
          ngModel.$setViewValue(html);
          if (eventType === 'blur') {
            // To update model value if model view value got update.
            ngModel.$commitViewValue();
          }
        }

        ngModel.$render = function() {
          element.html(ngModel.$viewValue || '');
        };

        element.bind('blur keyup change', function(event) {
          scope.$apply(read(event.type));
        });
      }
    }
  };
}
